// A small tint that accepts a text color & whether or not to apply the tint.
// Used in Hero, tiles, and so on.
import { BlockTextColor } from '@/types/blocks';
import { cva } from 'class-variance-authority';
import React from 'react';

interface TintProps {
  textColor?: BlockTextColor;
  tint: boolean;
}

export function Tint({ textColor = 'light', tint }: TintProps) {
  if (!tint) return null;

  const tintClasses = cva('absolute inset-0 z-0', {
    variants: {
      textColor: {
        light: 'bg-black/30',
        dark: 'bg-white/30',
      },
    },
  });

  return <div data-test='tint' className={tintClasses({ textColor })} />;
}
